import React, { useMemo } from "react";
import { useApiClient } from "../../../../shared/customHooks";
import { useApplicationContext } from "../../context/applicationContext";
import BaseComponent from "../../../../shared/baseComponent/BaseComponent";
import { appealRequestFormLegacy } from "../../../../shared/formObjects/application/legacy/appealRequestFormLegacy";

export default function AppealRequetComponentLegacy({ disabled, data, showBack = false }: any) {
  const {
    application: { nextApplicationId, hasAppeal },
    applicationBase,
    id,
  } = useApplicationContext();

  const context = useMemo(() => {
    return {
      nextApplicationId,
      hasAppeal,
      discriminator: applicationBase.discriminator,
    };
  }, []);

  return (
    <>
      {applicationBase.assignStatus?.status == "Finalised" && (
        <BaseComponent
          formBody={appealRequestFormLegacy}
          headerLabel="Appeal Request"
          editPath="appealRequest"
          apiClient={useApiClient("AppealRequestLegacy")}
          disabled={disabled || hasAppeal}
          showInternalNotes={false}
          formContext={context}
          data={data}
          showBack={showBack}
          showEdit={disabled && !hasAppeal}
          id={id}
        />
      )}
    </>
  );
}
